import { effectTiming } from './utils';
/**
 * Transform mark from transparent to solid.
 */
export const PathIn = (options) => {
    return (from, to, value, coordinate, defaults) => {
        var _a, _b;
        const [shape] = from;
        const length = ((_b = (_a = shape).getTotalLength) === null || _b === void 0 ? void 0 : _b.call(_a)) || 0;
        const keyframes = [
            { lineDash: [0, length] },
            { lineDash: [length, 0] },
        ];
        return shape.animate(keyframes, effectTiming(defaults, value, options));
    };
};
PathIn.props = {};
//# sourceMappingURL=pathIn.js.map